const translations: Record<string, string> = {
  // Nav
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.services': 'Services',
  'nav.partners': 'Partners',
  'nav.tradeData': 'Trade Data',
  'nav.gallery': 'Gallery',
  'nav.getInTouch': 'Get in Touch',

  // Hero
  'hero.eyebrow': 'Brand Export/Import Consulting, Distribution & Marketing',
  'hero.headline1': 'KOREA · VIETNAM',
  'hero.headline2': 'Brand Gateway\u00a0',
  'hero.headline3': 'Monaru',
  'hero.desc': 'We directly activate local networks in Korea and Vietnam to handle complex certifications and immediately execute major channel placements. We minimize trial and error in brand market entry and promise only certain results.',
  'hero.cta1': 'View Services',
  'hero.cta2': 'Start Partnership',
  'hero.scroll': 'Scroll',
  'hero.stat.tradeVolume': 'Trade Volume',
  'hero.stat.activePartners': 'Active Partners',
  'hero.stat.yearsExp': 'Years Experience',
  'hero.stat.nationsServed': 'Nations Served',

  // About Preview
  'about.eyebrow': 'About Us',
  'about.established': 'Since 2026',
  'about.heading1': 'Global Brand Expansion Partner',
  'about.heading2': 'We Create',
  'about.desc1': 'Uncertainty about unfamiliar markets turns into confidence. MONARU directly activates local networks in Korea and Vietnam, serving as a total solution partner responsible for every step — from your brand\'s first Seeding to full Distribution. Grounded in vibrant local market insight and professional certification processes, we guide your business to the heart of each market, safely and swiftly.',
  'about.pillar1.title': 'Certification & Customs',
  'about.pillar1.desc': 'One-stop handling of MFDS, CR, and all complex regulatory approvals in both markets.',
  'about.pillar2.title': 'Distribution Channel Entry',
  'about.pillar2.desc': 'Direct placement into hypermarkets, convenience stores, and major online platforms.',
  'about.pillar3.title': 'Brand Localization',
  'about.pillar3.desc': 'Marketing strategies tailored to consumer trends in each country to establish your brand.',
  'about.stat1.value': '14+',
  'about.stat1.label': 'Years of Expertise',
  'about.stat2.value': '120+',
  'about.stat2.label': 'Active Partners',
  'about.stat3.value': '2 Hubs',
  'about.stat3.label': 'Direct Networks',
  'about.bridge': 'Direct Bridge',
  'about.learnStory': 'Learn More About Us',

  // Services Preview
  'services.eyebrow': 'Services',
  'services.heading1': 'Comprehensive Trade',
  'services.heading2': 'Solutions & Services',
  'services.viewAll': 'View All Services',
  'services.explore': 'Explore Services',

  // Trade Data
  'tradeData.eyebrow': 'Real-Time Insights',
  'tradeData.heading1': 'Trade Flow',
  'tradeData.heading2': 'Analytics',
  'tradeData.desc1': 'Track bilateral trade flows between Korea and Vietnam with our comprehensive data platform. Make informed decisions with real-time metrics, trend analysis, and sector breakdowns.',
  'tradeData.desc2': 'Updated monthly with data from KITA, VCCI, and customs authorities of both nations.',
  'tradeData.viewDashboard': 'View Full Dashboard',
  'tradeData.vsPriorYear': 'vs prior year',

  // Partners
  'partners.trustedBy': 'Trusted By',
  'partners.heading': 'Strategic Partners',
  'partners.sub': 'Building Success Together',
  'partners.viewAll': 'View All Partners',

  // CTA
  'cta.eyebrow': 'Ready to Start?',
  'cta.heading': 'Gateway to Korea-Vietnam Trade',
  'cta.desc': 'Connect with our trade specialists and discover how MONARU can accelerate your business across one of Asia\'s fastest-growing trade corridors.',
  'cta.primary': 'Get Free Consultation',
  'cta.secondary': 'Explore Services',

  // Footer
  'footer.tagline': 'Bringing brand sincerity into the everyday lives of global consumers.',
  'footer.services': 'Services',
  'footer.company': 'Company',
  'footer.copyright': '© 2025 MONARU. All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.cookies': 'Cookie Policy',
  'footer.svc1': 'Certification & Customs',
  'footer.svc2': 'Distribution Channel Entry',
  'footer.svc3': 'Brand Localization',
  'footer.svc4': 'Market Entry Consulting',
  'footer.svc5': 'Brand Sourcing & Discovery',
  'footer.svc6': 'Logistics & Delivery',
  'footer.aboutUs': 'About Us',
  'footer.ourPartners': 'Partners',
  'footer.gallery': 'Gallery',
  'footer.tradeData': 'Trade Data',
  'footer.contactUs': 'Contact Us',
  'footer.ftaGuide': 'Korea-Vietnam FTA Guide',
  'footer.tradeStats': 'Trade Statistics',
  'footer.shippingSchedules': 'Shipping Schedules',
  'footer.regulatoryUpdates': 'Regulatory Updates',

  // About Page
  'aboutPage.eyebrow': 'About Us',
  'aboutPage.heading2': 'MONARU',
  'aboutPage.heroDesc': 'The gateway for everyone. A hub connecting two of Asia\'s most dynamic economies.',
  'aboutPage.story.eyebrow': 'Our Story',
  'aboutPage.story.heading': 'From Seoul to Saigon — A Decade of Trade',
  'aboutPage.story.p1': 'In 2010, a small team of Korean and Vietnamese trade professionals recognized a critical gap: despite the enormous potential of Korea-Vietnam commerce, businesses on both sides lacked a trusted, bilingual partner who truly understood both markets.',
  'aboutPage.story.p2': 'KV Trade Alliance was born from that insight. Starting with just 12 specialists in a Seoul office, we built our reputation one shipment, one deal, one partnership at a time.',
  'aboutPage.story.p3': 'Today, with 85+ professionals spanning both capitals, we have grown into the region\'s most trusted bilateral trade agency — facilitating over $4.2 billion in annual trade and serving Fortune 500 clients alongside ambitious SMEs.',
  'aboutPage.story.cta': 'Partner With Us',
  'aboutPage.values.eyebrow': 'Our Foundation',
  'aboutPage.values.heading': 'Mission & Values',
  'aboutPage.values.sub': 'What drives every decision we make',
  'aboutPage.milestones.eyebrow': 'Our Journey',
  'aboutPage.milestones.heading': 'Key Milestones',
  'aboutPage.value.partnership.title': 'Partnership First',
  'aboutPage.value.partnership.desc': 'We build lasting relationships, not just transactions. Your growth is our success.',
  'aboutPage.value.integrity.title': 'Integrity Always',
  'aboutPage.value.integrity.desc': 'Transparent dealings, honest advice, and ethical practices in every market we serve.',
  'aboutPage.value.innovation.title': 'Innovation Driven',
  'aboutPage.value.innovation.desc': 'Leveraging technology and data to deliver smarter, faster, more efficient trade solutions.',
  'aboutPage.value.local.title': 'Local Expertise',
  'aboutPage.value.local.desc': 'Deep cultural and regulatory knowledge in both Korea and Vietnam — your competitive advantage.',
  'aboutPage.ms.2010.title': 'Founded in Seoul',
  'aboutPage.ms.2010.desc': 'KV Trade Alliance established with a team of 12 trade specialists focused on Korea-Vietnam bilateral commerce.',
  'aboutPage.ms.2013.title': 'Ho Chi Minh City Office',
  'aboutPage.ms.2013.desc': 'Opened our first Vietnamese office, becoming the first Korean trade agency with a permanent presence in HCMC.',
  'aboutPage.ms.2016.title': '$1B Trade Milestone',
  'aboutPage.ms.2016.desc': 'Crossed $1 billion in facilitated bilateral trade, serving over 200 corporate clients across both nations.',
  'aboutPage.ms.2019.title': 'FTA Specialist Certification',
  'aboutPage.ms.2019.desc': 'Became an officially recognized Korea-Vietnam FTA specialist firm, achieving preferential tariff savings for 90% of clients.',
  'aboutPage.ms.2022.title': 'Digital Trade Platform',
  'aboutPage.ms.2022.desc': 'Launched our proprietary trade analytics and cargo tracking platform, transforming how clients manage cross-border logistics.',
  'aboutPage.ms.2024.title': '$4.2B Record Year',
  'aboutPage.ms.2024.desc': 'Achieved record $4.2B in facilitated trade volume with 1,240+ active corporate partners across 24 nations.',

  // Services Page
  'servicesPage.eyebrow': 'MONARU Services',
  'servicesPage.heading1': 'Brand Market Entry Package',
  'servicesPage.heading2': 'All Together',
  'servicesPage.heroDesc': 'From certification to distribution and brand localization — minimize trial and error when entering the Korean and Vietnamese markets and focus only on definite results. MONARU is with you every step of the way.',
  'servicesPage.cta.heading': 'Ready to Start Your Brand Market Entry?',
  'servicesPage.cta.desc': 'Start a free consultation with a specialist now and receive a customized entry strategy tailored to your brand.',
  'servicesPage.cta.btn': 'Request Free Consultation',
  'servicesPage.enquireNow': 'Enquire Now',

  // Contact Page
  'contactPage.eyebrow': 'Get In Touch',
  'contactPage.heading1': 'How Can We Help You?',
  'contactPage.heading2': 'Trade Journey',
  'contactPage.heroDesc': 'Our team of specialists is ready to help. Please send us a message using the form below.',
  'contactPage.offices.heading': 'Our Offices',
  'contactPage.offices.seoul': 'Seoul Headquarters',
  'contactPage.offices.hcmc': 'Ho Chi Minh City',
  'contactPage.offices.hours': 'Business Hours',
  'contactPage.offices.hoursMF': 'Monday – Friday: 09:00 – 18:00 KST',
  'contactPage.offices.hoursSat': 'Saturday: 09:00 – 13:00 KST',
  'contactPage.offices.hoursNote': 'Emergency line available 24/7 for active shipments',
  'contactPage.form.heading': 'Send Us a Message',
  'contactPage.form.sub': 'Fill out the form and a specialist will respond within one business day.',
  'contactPage.form.name': 'Full Name',
  'contactPage.form.email': 'Email Address',
  'contactPage.form.company': 'Company',
  'contactPage.form.service': 'Service Interest',
  'contactPage.form.serviceSelect': 'Select a service',
  'contactPage.form.message': 'Message',
  'contactPage.form.messagePlaceholder': 'Tell us about your trade requirements...',
  'contactPage.form.submit': 'Send Message',
  'contactPage.form.submitting': 'Sending...',
  'contactPage.form.successTitle': 'Message Received',
  'contactPage.form.successDesc': 'Thank you for reaching out. Our team will contact you within one business day.',
  'contactPage.form.error': 'Something went wrong. Please try again or email us directly.',

  // Import Brands
  'importBrands.eyebrow': 'Import Brands',
  'importBrands.heading1': 'Vietnamese Premium Brands',
  'importBrands.heading2': 'Official Import & Distribution in Korea',
  'importBrands.subDesc': 'Curated Vietnamese brands exclusively imported and distributed in Korea by MONARU',
  'importBrands.badge': 'Official Import Partner',
  'importBrands.established': 'Established',
  'importBrands.aboutBrand': 'Brand Overview',
  'importBrands.officialPartner': 'MONARU Official Korea Import & Distribution',
  'importBrands.officialPartnerDesc': 'Nationwide Korean distribution and B2B supply through MONARU',
  'importBrands.productLine': 'Product Line',
  'importBrands.ctaInquiry': 'Import Inquiry',
  'importBrands.ctaCatalog': 'Request Catalog',
  'importBrands.stat.origin': 'Origin',
  'importBrands.stat.exportCountries': 'Export Countries',
  'importBrands.stat.heritage': 'Brand Heritage',
  'importBrands.stat.marketShare': 'Vietnam Instant Coffee',

  // Brands Preview
  'brands.eyebrow': 'Import · Export Brands',
  'brands.heading1': 'MONARU Partner Brands',
  'brands.heading2': 'Featured Brands',
  'brands.inquiry': 'Brand Inquiry',
  'brands.import': 'Import Brand',
  'brands.export': 'Export Brand',
  'brands.inquireNow': 'Inquire Now',

  // Partners Page
  'partnersPage.eyebrow': 'Network',
  'partnersPage.heading1': 'Strategic Partners',
  'partnersPage.heading2': 'Bridging Two Nations',
  'partnersPage.heroDesc': 'From government agencies to large corporations and SMEs — our trusted network spanning Korea and Vietnam is ready to connect you.',
  'partnersPage.section.eyebrow': 'Brand Gateway',
  'partnersPage.section.heading': 'MONARU Partners',
  'partnersPage.section.sub': 'Building success together across both nations',
  'partnersPage.kr.label': 'Korean Partners',
  'partnersPage.vn.label': 'Vietnamese Partners',
  'partnersPage.cta.eyebrow': 'Join Our Network',
  'partnersPage.cta.heading': 'Become a Strategic Partner',
  'partnersPage.cta.desc': 'Over 1,240 companies are leveraging the Korea-Vietnam trade corridor. Grow with the region\'s most trusted bilateral trade agency.',
  'partnersPage.cta.btn': 'Apply for Partnership',

  // Gallery Page
  'galleryPage.eyebrow': 'Visual Stories',
  'galleryPage.heading1': 'Gallery',
  'galleryPage.heading2': 'Korea · Vietnam',
  'galleryPage.heroDesc': 'A visual journey through our ports, partnerships, trade missions, and the landmarks that define the Korea-Vietnam corridor.',
  'galleryPage.filter.all': 'All',
  'galleryPage.filter.korea': 'Korea',
  'galleryPage.filter.vietnam': 'Vietnam',
  'galleryPage.filter.events': 'Events',
  'galleryPage.allPhotos': 'All Photos',

  // Contact Form Service Options
  'contactPage.form.service.koreanExport': 'Korean Brand Export Inquiry',
  'contactPage.form.service.vietnamDist': 'Vietnamese Brand Distribution Inquiry',

  // Trade Data Page
  'tradeDataPage.eyebrow': 'Analytics Hub',
  'tradeDataPage.heading1': 'Trade Flow',
  'tradeDataPage.heading2': 'Analytics Dashboard',
  'tradeDataPage.desc': 'Real-time Korea-Vietnam bilateral trade metrics, sector analysis, and trend forecasting. Data sourced from KITA, VCCI, and customs authorities.',
  'tradeDataPage.monthly.title': 'Monthly Trade Volume (USD millions)',
  'tradeDataPage.monthly.sub': 'Korea & Vietnam bilateral exports — FY2024',
  'tradeDataPage.category.title': 'Trade by Category (%)',
  'tradeDataPage.category.sub': 'Sector distribution of bilateral trade',
  'tradeDataPage.distribution.title': 'Trade Distribution',
  'tradeDataPage.distribution.sub': 'Overall composition by sector',
  'tradeDataPage.stat.totalVolume': 'Total Trade Volume',
  'tradeDataPage.stat.activeCompanies': 'Active Companies',
  'tradeDataPage.stat.shipments': 'Shipments Processed',
  'tradeDataPage.stat.nations': 'Partner Nations',
  'tradeDataPage.korea.exports': 'Korea Exports',
  'tradeDataPage.vietnam.exports': 'Vietnam Exports',
  'tradeDataPage.korea.label': 'Korea',
  'tradeDataPage.vietnam.label': 'Vietnam',
  'tradeDataPage.yoy': 'YoY',

  // Page Titles
  'page.title.home': 'MONARU | Korea·Vietnam Brand Gateway',
  'page.title.about': 'MONARU | About',
  'page.title.services': 'MONARU | Services',
  'page.title.partners': 'MONARU | Partners',
  'page.title.tradeData': 'MONARU | Trade Data',
  'page.title.gallery': 'MONARU | Gallery',
  'page.title.contact': 'MONARU | Contact',
  'page.title.news': 'MONARU | News',

  // Nav - News
  'nav.news': 'News',

  // News Page
  'newsPage.eyebrow': 'Latest Updates',
  'newsPage.heading1': 'MONARU',
  'newsPage.heading2': 'News & Insights',
  'newsPage.heroDesc': 'Stay up to date with the latest news, industry insights, and MONARU activities in Korea-Vietnam trade.',
  'newsPage.all': 'All',
  'newsPage.readMore': 'Read More',
  'newsPage.empty': 'No posts available.',
  'newsPage.backToList': 'Back to List',
  'newsPage.publishedAt': 'Published',
  'newsPage.by': 'By',
  'newsPage.share': 'Share',
  'newsPage.notFound': 'Post not found.',
};

export default translations;
